import { get } from "lodash";
import { ResidentialStatusEnum } from "../enum/residential-status.enum";
import { SexEnum } from "../enum/sex.enum";
import { RaceType } from "../enum/race.enum";
import { NationalityType } from "../enum/nationality.enum";
import { RoleNameType } from "../enum/role-name.enum";
import { SingpassTypeEnum } from "../enum/singpass-type.enum";

export class MyInfo {
  uinfin              : string;
  name                : string;
  hanyupinyinname     : string;
  sex                 : SexEnum;
  race                : RaceType | null;
  nationality         : NationalityType | null;
  residential_status  : ResidentialStatusEnum | string;
  dob                 : string;
  mobile_no           : string;
  marital_status      : string;
  email               : string;
  
  constructor(initial?: any) {
    this.uinfin               = get(initial, 'uinfin',             '');
    this.name                 = get(initial, 'name',               '');
    this.hanyupinyinname      = get(initial, 'hanyupinyinname',    '');
    this.residential_status   = get(initial, 'residential_status', '');
    this.dob                  = get(initial, 'dob',                '');
    this.mobile_no            = get(initial, 'mobile_no',          '');
    this.marital_status       = get(initial, 'marital_status',     '');
    this.email                = get(initial, 'email',              '');
    this.sex                  = get(initial, 'sex',                null);
    this.race                 = get(initial, 'race',               null);
    this.nationality          = get(initial, 'nationality',        null);
  }
}            
type LiveStatusStatus = "A" | "D";                                                     
export class MyInfoWithDOD extends MyInfo {
  dod:string;
  live_status: LiveStatusStatus;  
  role_name: RoleNameType;  
  constructor(initial?: Partial<MyInfoWithDOD>) {
    super(initial);
    this.dod                 = get(initial, 'dod',                '');
    this.live_status         = get(initial, 'live_status',        'A') || "A"; //PREVENT FALSY VALUE
    this.role_name           = get(initial, 'role_name',            '');
  }
}                                                                

export class AdministrativeRole extends MyInfoWithDOD {
  representee_uinfin: string;
  constructor(initial?: Partial<AdministrativeRole>) {
    super(initial)
    this.representee_uinfin = get(initial, 'representee_uinfin', '');
  }
}


export class SingpassLoginMyInfo extends MyInfo {
  login_type?: SingpassTypeEnum;
  corppass_detail?: CorppassDetails;
  constructor(initial?: any) {
    super(initial);
    this.login_type = get(initial, 'login_type', undefined);
    this.corppass_detail = get(initial, 'corppass_detail', new CorppassDetails());
  }
}

export class CorppassDetails {
  uen: string;
  constructor(initial?: any) {
    this.uen = get(initial, 'uen', '');
  }
}